<template>
  <v-container fluid>
    <v-alert type="warning" max-width="600" class="mx-auto mt-5" prominent>
      <h2>Your user account does not have import/export permissions</h2>
      This page requires import/export permissions. Please have an administrator grant you the necessary permissions if
      you need access.
    </v-alert>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
    };
  },
};
</script>